import dayjs from 'dayjs';

export const getDisplayCreatedAt = (createdAt: string) => {
  const now = dayjs();
  const createdAtDayjs = dayjs(createdAt + 'Z');

  if (now.diff(createdAtDayjs, 'h') >= 24) {
    return createdAtDayjs.format('YYYY.MM.DD');
  } else if (now.diff(createdAtDayjs, 'h') >= 1) {
    return `${now.diff(createdAtDayjs, 'h')}시간 전`;
  } else if (now.diff(createdAtDayjs, 'm') >= 1) {
    return `${now.diff(createdAtDayjs, 'm')}분 전`;
  } else {
    return '방금 전';
  }
};
